import { useLayoutEffect, useRef, type ReactNode } from "react";
import { useLocation, useMatches } from "react-router";

export interface MainProps {
    children: ReactNode;
}

/** 主内容容器，统一保留旧 Vue 页面内容区的滚动和内边距入口。 */
export function Main({ children }: MainProps) {
    const location = useLocation();
    const matches = useMatches();
    const mainRef = useRef<HTMLElement>(null);
    const routeTitle = [...matches]
        .reverse()
        .map(match => (match.handle as { title?: unknown } | undefined)?.title)
        .find((title): title is string => typeof title === "string" && title.length > 0);

    useLayoutEffect(() => {
        /** 路由页签可能复用表格节点，进入页面时必须恢复旧 Vue 从首列开始的初始位置。 */
        const resetTableHorizontalScroll = () => {
            mainRef.current
                ?.querySelectorAll<HTMLElement>(".zh-table .ant-table-body, .zh-table .ant-table-content")
                .forEach(scrollContainer => {
                    scrollContainer.scrollLeft = 0;
                });
        };

        resetTableHorizontalScroll();
        const animationFrame = window.requestAnimationFrame(resetTableHorizontalScroll);
        return () => window.cancelAnimationFrame(animationFrame);
    }, [location.key, location.pathname, location.search]);

    return (
        <main ref={mainRef} className="layout-main-container">
            {routeTitle ? <div className="route-title">{routeTitle}</div> : null}
            {children}
        </main>
    );
}

export default Main;
